export const formatPhoneNumber = (phone: string) => {
  if (!phone) return ''

  return phone.includes('+1') ? phone : `+1${phone}`
}
